import { Controller, useFormContext } from 'react-hook-form'

import { sarSubjectRoleInSuspiciousActivityTypes } from 'commons/types/dictionaries'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

const EMPTY_OPTION = { label: 'Not selected', value: '' }

type RoleInActivityProps = {
  index: number
}

export const RoleInActivity = ({ index }: RoleInActivityProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`subjectsInfo.${index as 0}.roleInActivity`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="28. Subject's role in suspicious activity"
          input={(props) => (
            <Select {...props} data={sarSubjectRoleInSuspiciousActivityTypes} emptyOption={EMPTY_OPTION} />
          )}
        />
      )}
    />
  )
}
